<template>
    <div>
        <ds-list-item
            v-for="item in listItems"
            :key="item.id"
            #title
            clickable
            target="_blank"
            @click="handleClick(item)"
        >
            <ds-avatar :name="item.id.toString()" /> {{ item.label }}
        </ds-list-item>

        <ds-modal
            v-if="!isUpdateHelpArticleLinksEnabled"
            :is-open="isOpen"
            show-close
            size="med"
            title="Make unsubscribe link easily accessible"
            @close="closeUnsubscribeModal"
        >
            <div>
                <p>
                    Make it easy for people to unsubscribe! Don’t attempt to hide the unsubscribe link by adding extra spacing.
                    If your recipients cannot find the opt-out link they will resort to reporting the email as spam.
                    This can contribute to complaint rates that can damage your email reputation.
                </p>
                <p>
                    For Keap Broadcasts and marketing emails in Automations, the Unsubscribe link is automatically appended at the bottom of the design as part of CAN-SPAM laws.
                </p>
            </div>
        </ds-modal>
    </div>
</template>


<script>

import amplitude from '../util/analytics/amplitude';

const HELP_ARTICLE_LINKS = [
    {
        id: 1,
        link: 'https://learn.thryv.com/hc/en-us/articles/37328891391117-Understanding-Spam-Complaints-with-Keap',
        label: 'Spam Complaints Explained',
    },
    {
        id: 2,
        link: 'https://learn.thryv.com/hc/en-us/articles/37026226668813-List-Hygiene-with-Keap',
        label: 'Review List Hygiene',
    },
    {
        id: 3,
        link: 'https://learn.thryv.com/hc/en-us/articles/40495873428749-Gaining-Explicit-Permission-for-Email-Marketing-with-Keap',
        label: 'Opt-in: Explicit Permission and Expectations',
    },
    {
        id: 4,
        link: 'https://learn.thryv.com/hc/en-us/articles/37443318628621-How-to-Avoid-Content-Filters-In-Email-Marketing-with-Keap',
        label: 'Check your Content and Subject Line',
    },
    {
        id: 5,
        link: 'https://learn.thryv.com/hc/en-us/articles/41656089250573-Make-it-Easy-to-Unsubscribe-with-Keap',
        label: 'Make it easy to Unsubscribe',
    },
    {
        id: 6,
        link: 'https://learn.thryv.com/hc/en-us/articles/41656746188173-Send-a-Confirmation-Email-with-Keap',
        label: 'Send a Confirmation Email',
    }
];

export default {
    props: {
        isUpdateHelpArticleLinksEnabled: {
            type: Boolean,
            default: false,
        },
        appEdition: String,
    },
    data() {
        return {
            isOpen: false,
        };
    },

    computed: {
        icon() {
            return 'circle';
        },
        time() {
            return '10 mins';
        },

        listItems() {
            return HELP_ARTICLE_LINKS;
        },
    },
    methods: {
        handleClick(object) {
            if (object.id === 2 && !this.isUpdateHelpArticleLinksEnabled) {
                this.navigateToListItemModal();
            } else {
                window.open(object.link, '_blank');
            }
            this.emitAmplitudeEvent(object.label);
        },
        openUnsubscribeModal() {
            this.isOpen = true;
        },
        closeUnsubscribeModal() {
            this.isOpen = false;
        },
        navigateToListItemModal() {
            this.emitAmplitudeEvent('CTA 2: make unsubscribe link easily accessible');
            this.openUnsubscribeModal();
        },
        emitAmplitudeEvent(event) {
            amplitude.infusionsoft.track('Email Analytics - CTA / Help', {
                'Event Source': 'Email Analytics Complaints Page',
                Destination: event,
            });
        },
    },
};

</script>

<style lang="scss" scoped>

    .title-wrapping {
        display: flex;
        overflow-wrap: break-word;
    }

    .list-item-time {
        font-size: $font-size-xs;
        line-height: $font-size-md;
        color: $color-gray-800;
        padding-bottom: $spacing-050;
        display: flex;
    }

    .one-line {
        display: flex;
    }

    .list-item-description {
        font-size: $font-size-md;
        padding-right: $spacing-200;
        font-color: $color-gray-900;
        display: flex;
        overflow-wrap: break-word;
    }

    .task-time {
        display: flex;
        justify-content: center;
        align-content: center;
        flex-direction: column;
        padding-left: $spacing-050;
    }

    .clock-with-time {
        flex: auto;
    }

</style>
